// Module
var code = "<div class=\"customer\">\n  <div ui-view></div>\n</div>\n";
// Exports
module.exports = code;